import axios from 'axios';
import dayjs from 'dayjs';
import Vue from 'vue';

export default {
  state: {
    application: {
      eisCode: null,
      status: null,
    },
    applicationBlob: null,
    signedApplicationBlob: null,
    applications: [],
    loading: false,
    activeTabName: 'applicationForm',
    cAList: [],
    total: 0,
  },
  mutations: {
    SET_APPLICATION_DATA(state, data) {
      state.application = Object.assign({}, state.application, data);
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_ACTIVE_TAB(state, value) {
      state.activeTabName = value;
    },
    SET_APPLICATIONS(state, data) {
      state.applications = data;
    },
    SET_TOTAL(state, data) {
      state.total = data;
    },
    SET_STATUS(state, status) {
      state.application.status = status;
    },
    SET_STATUS_IS_EDIT(state, data) {
      Vue.set(state.applications[data.index], 'isEdit', data.value);
    },
    SET_APPLICATION_BLOB(state, blob) {
      state.applicationBlob = blob;
    },
    SET_SIGNED_APPLICATION_BLOB(state, blob) {
      state.signedApplicationBlob = blob;
    },
    SET_CA_LIST(state, list) {
      state.cAList = list;
    }
  },
  getters: {
    getApplications: (state) => {
      return state.applications;
    },
  },
  actions: {
    // eslint-disable-next-line
    createApplication({}, data) {
      data.created = dayjs();
      return new Promise((resolve, reject) => {
        data.updated = dayjs();
        axios({ url: '/api/application/create', data, method: 'POST' })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    // eslint-disable-next-line
    uploadDocuments({}, formData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/api/application/upload-documents', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then(function (resp) {
            resolve(resp);
          })
          .catch(function (err) {
            reject(err);
          });
      });
    },
    setApplicationData({ commit }, data) {
      commit('SET_APPLICATION_DATA', data);
    },
    setActiveTab({ commit }, data) {
      commit('SET_ACTIVE_TAB', data);
    },
    getAllApplications({ commit }, params) {
      commit('SET_LOADING', true);
      axios
        .get('/api/application/all', {
          params,
        })
        .then(
          (response) => {
            commit('SET_APPLICATIONS', response.data.applications);
            commit('SET_TOTAL', response.data.total);
            commit('SET_LOADING', false);
          },
          (error) => {
            console.log(error);
            commit('SET_LOADING', false);
          }
        );
    },
    getApplicationStatus({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios({ url: '/api/application/status', params, method: 'GET' })
          .then((resp) => {
            commit('SET_STATUS', resp.data.status);
            commit('SET_APPLICATION_DATA', resp.data);
            resolve(resp);
          })
          .catch((err) => {
            commit('SET_STATUS');
            commit('SET_LOADING', false);
            reject(err);
          });
      });
    },
    statusIsEdit({ commit }, data) {
      commit('SET_STATUS_IS_EDIT', data);
    },
    setApplicationBlob({ commit }, blob) {
      commit('SET_APPLICATION_BLOB', blob);
    },
    setSignedApplicationBlob({ commit }, blob) {
      commit('SET_SIGNED_APPLICATION_BLOB', blob);
    },
    getCaList( { commit }) {
      axios.get('/api/application/ca-list').then(resp => {
        commit('SET_CA_LIST', resp.data);
    }).catch(e => console.log(e));
    }
  },
};
